import { IonContent } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { AppHeader } from "../../../components/Header/AppHeader";
import { setCurrentView } from "../../../services/users";
import UserDashboard from "./components/UserDashboard";

export interface RouteParams {
	id: string;
}

interface props {
	usersData: any;
	setCurrentView: any;
	currentUser: any;
}

export const User: React.FC<props> = ({
	usersData,
	setCurrentView,
	currentUser,
}) => {
	let { id } = useParams<RouteParams>();
	const history = useHistory();

	const [user, setUser] = useState<any>([]);
	const { displayName } = user;

	// useEffect(()=>{
	// 	console.log(user);
	// },[user]);

	useEffect(() => {
		if (usersData) {
			if (currentUser.isAdmin && usersData[id]) {
				// setUser(usersData[id]);
				setUser({ uid: id, ...usersData[id] });
				setCurrentView(id);
			} else {
				setUser(currentUser);
			}
		}
		//eslint-disable-next-line
	}, [usersData]);

	return (
		<>
			<AppHeader title={displayName} />
			<IonContent fullscreen className="ion-padding">
				{user && user.uid && <UserDashboard user={user} />}
			</IonContent>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	usersData: state.user.users,
	currentUser: state.user.userDetails,
});

const mapDispatchToProps = {
	setCurrentView,
};

export default connect(mapStateToProps, mapDispatchToProps)(User);
